import { useSmOrMdScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";

interface BackgroundWrapperProps {
  children: React.ReactNode;
  withCircleBranding?: boolean;
  isVerticallyCenteredOnMobile?: boolean;
  background: "light" | "dark" | "discover";
}

const getBackgroundClass = (
  isSmScreen: boolean,
  withCircleBranding: boolean,
  background: "light" | "dark" | "discover",
): string => {
  if (isSmScreen || !withCircleBranding) return "bg-primary md:bg-secondary";
  if (background === "discover") return "discoverBackground";
  return background === "light" ? "lightBackground" : "darkBackground";
};

export const BackgroundWrapper = ({
  children,
  withCircleBranding = true,
  isVerticallyCenteredOnMobile = false,
  background,
}: BackgroundWrapperProps) => {
  const isSmScreen = useSmOrMdScreenMediaQuery();
  const backgroundClass = getBackgroundClass(
    isSmScreen,
    withCircleBranding,
    background,
  );
  const verticalAlignmentClass = isVerticallyCenteredOnMobile
    ? "items-center"
    : "md:items-center";

  return (
    <div
      className={`text-dark flex min-h-screen w-full min-w-full justify-center ${verticalAlignmentClass} ${backgroundClass}`}
    >
      {children}
    </div>
  );
};
